/**
 * CUSTOM ADD TO CART — wires custom product-card forms into Horizon theme's
 * native cart-icon (header bubble) and cart-drawer (mini-cart) components.
 *
 * Works via event delegation on document, so ANY current or future section
 * using the .product-card__atc-form / [data-atc-button] pattern gets this
 * behavior automatically — no per-section JS needed.
 *
 * Include once, globally, in layout/theme.liquid:
 *   <script src="{{ 'custom-add-to-cart.js' | asset_url }}" defer></script>
 */
(function () {
  function getCartIcon() {
    return document.querySelector('cart-icon');
  }

  function getCartDrawer() {
    return document.querySelector('theme-drawer#cart-drawer');
  }

  function updateCartIcon(itemCount) {
    var cartIcon = getCartIcon();
    if (!cartIcon) return;

    var apply = function () {
      if (typeof cartIcon.renderCartBubble === 'function') {
        cartIcon.renderCartBubble(itemCount);
      }
    };

    if (window.customElements && customElements.get('cart-icon')) {
      apply();
    } else if (window.customElements) {
      customElements.whenDefined('cart-icon').then(apply);
    }
  }

  function refreshCartDrawer() {
    return fetch(window.location.pathname + '?sections=cart-drawer-section', {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (sections) {
        var html = sections['cart-drawer-section'];
        var wrapper = document.getElementById('shopify-section-cart-drawer-section');
        if (wrapper && html) {
          wrapper.innerHTML = html;
        }
      })
      .catch(function (err) {
        console.warn('[custom-add-to-cart] Could not refresh cart drawer:', err);
      });
  }

  function openCartDrawer() {
    var drawer = getCartDrawer();
    if (!drawer) return;

    var apply = function () {
      var freshDrawer = getCartDrawer();
      if (freshDrawer && typeof freshDrawer.open === 'function') {
        freshDrawer.open();
      }
    };

    if (window.customElements && customElements.get('theme-drawer')) {
      apply();
    } else if (window.customElements) {
      customElements.whenDefined('theme-drawer').then(apply);
    }
  }

  function flyToCart(imageEl, cartIconEl) {
    if (!imageEl || !cartIconEl) return;

    var imgRect = imageEl.getBoundingClientRect();
    var cartRect = cartIconEl.getBoundingClientRect();

    if (imgRect.width === 0 || imgRect.height === 0) return;
    if (cartRect.width === 0 && cartRect.height === 0) return;

    var flyingImg = imageEl.cloneNode(true);
    flyingImg.style.position = 'fixed';
    flyingImg.style.left = imgRect.left + 'px';
    flyingImg.style.top = imgRect.top + 'px';
    flyingImg.style.width = imgRect.width + 'px';
    flyingImg.style.height = imgRect.height + 'px';
    flyingImg.style.margin = '0';
    flyingImg.style.borderRadius = '8px';
    flyingImg.style.objectFit = 'cover';
    flyingImg.style.zIndex = '99999';
    flyingImg.style.pointerEvents = 'none';
    flyingImg.style.opacity = '1';
    flyingImg.style.transform = 'translate(0, 0) scale(1)';
    flyingImg.style.transition = 'transform 0.7s cubic-bezier(0.55, 0, 0.2, 1), opacity 0.6s ease 0.15s';
    flyingImg.style.willChange = 'transform, opacity';
    flyingImg.setAttribute('aria-hidden', 'true');

    document.documentElement.appendChild(flyingImg);

    var deltaX = (cartRect.left + cartRect.width / 2) - (imgRect.left + imgRect.width / 2);
    var deltaY = (cartRect.top + cartRect.height / 2) - (imgRect.top + imgRect.height / 2);

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        flyingImg.style.transform = 'translate(' + deltaX + 'px, ' + deltaY + 'px) scale(0.12)';
        flyingImg.style.opacity = '0.3';
      });
    });

    setTimeout(function () {
      flyingImg.remove();
    }, 750);
  }

  function handleAddToCartSubmit(event) {
    var form = event.target;
    if (!form || !form.classList || !form.classList.contains('product-card__atc-form')) return;

    event.preventDefault();

    var button = form.querySelector('[data-atc-button]');
    if (!button || button.disabled || button.classList.contains('is-loading')) return;

    button.classList.add('is-loading');
    var textEl = button.querySelector('.product-card__atc-text');
    var originalText = textEl ? textEl.textContent : '';

    var card = form.closest('.product-card');
    var cardImage = card ? card.querySelector('.product-card__image') : null;
    var cartIconEl = getCartIcon();
    if (cardImage && cartIconEl) {
      flyToCart(cardImage, cartIconEl);
    }

    var formData = new FormData(form);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (err) {
            throw new Error(err.description || 'Unable to add to cart');
          });
        }
        return response.json();
      })
      .then(function () {
        return fetch('/cart.js').then(function (res) {
          return res.json();
        });
      })
      .then(function (cart) {
        button.classList.remove('is-loading');
        button.classList.add('is-added');
        if (textEl) textEl.textContent = 'Added';

        updateCartIcon(cart.item_count);

        return refreshCartDrawer().then(function () {
          openCartDrawer();
        });
      })
      .then(function () {
        setTimeout(function () {
          button.classList.remove('is-added');
          if (textEl) textEl.textContent = originalText;
        }, 1800);
      })
      .catch(function (error) {
        console.warn('[custom-add-to-cart]', error);
        button.classList.remove('is-loading');
        if (textEl) {
          textEl.textContent = 'Error';
          setTimeout(function () {
            textEl.textContent = originalText;
          }, 1800);
        }
      });
  }

  document.addEventListener('submit', handleAddToCartSubmit);
})();